/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedEpsiOrderApproveRequest } from '../types/PatchedEpsiOrderApprove';
import type { EpsiOrderApproveResponse } from '../types/EpsiOrderApprove';

export type EpsiOrdersApprovePartialUpdateRequest = PatchedEpsiOrderApproveRequest;
export type EpsiOrdersApprovePartialUpdateResponse = EpsiOrderApproveResponse;

export type EpsiOrdersApprovePartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this epsi order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/epsi_orders/{id}/approve/
 *
 * ```yaml
 * operationId: epsi_orders_approve_partial_update
 * description: '{"state": "APPROVED"} nebo {"state": "REJECTED", "rejection_reason": "…"}.'
 * tags:
 *   - epsi_orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedEpsiOrderApprove'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedEpsiOrderApprove'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedEpsiOrderApprove'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/EpsiOrderApprove'
 *     description: ''
 * ```
 */
export const epsiOrdersApprovePartialUpdateOperation = ({
  id,
  ...rest
}: EpsiOrdersApprovePartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/epsi_orders/${id}/approve/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/epsi_orders/{id}/approve/' };
  };

/**
 * PATCH /dmx-server/epsi_orders/{id}/approve/
 *
 * ```yaml
 * operationId: epsi_orders_approve_partial_update
 * description: '{"state": "APPROVED"} nebo {"state": "REJECTED", "rejection_reason": "…"}.'
 * tags:
 *   - epsi_orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedEpsiOrderApprove'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedEpsiOrderApprove'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedEpsiOrderApprove'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/EpsiOrderApprove'
 *     description: ''
 * ```
 */
export const epsiOrdersApprovePartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: EpsiOrdersApprovePartialUpdateQuery;
  request: PatchedEpsiOrderApproveRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<EpsiOrderApproveResponse>> => {
  const operation = epsiOrdersApprovePartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
